module.exports = __webpack_public_path__ + "img/08.0636adb1.png";